export const defaultSeoConfig = {
  key: 'index',
  title: 'HSK Mock: the only official platform for practising HSK and YCT tests',
  description:
    'Web and mobile app, developed in partnership with the HSK exam board, for understanding the world’s most popular Chinese language proficiency tests and for practising HSK and YCT tests with real recent past papers.  Descriptions, test format, vocab, listening, reading and writing samples and mock tests for all HSK levels',
}

export default [
  {
    key: 'index',
    title: 'HSK Mock: the only official platform for practising HSK and YCT tests',
    description:
      'Web and mobile app, developed in partnership with the HSK exam board, for understanding the world’s most popular Chinese language proficiency tests and for practising HSK and YCT tests with real recent past papers.  Descriptions, test format, vocab, listening, reading and writing samples and mock tests for all HSK levels',
  },
  {
    name: 'HskAbout',
    key: 'YCT 1',
    title: 'YCT 1 on the only official platform for practising YCT tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Youth Chinese Test Level 1 (YCT1).  Developed in partnership with the HSK exam board and available via web and mobile app',
  },
  {
    name: 'HskAbout',
    key: 'YCT 2',
    title: 'YCT 2 on the only official platform for practising YCT tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Youth Chinese Test Level 2 (YCT2).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'YCT 3',
    title: 'YCT 3 on the only official platform for practising YCT tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Youth Chinese Test Level 3 (YCT3).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'YCT 4',
    title: 'YCT 4 on the only official platform for practising YCT tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Youth Chinese Test Level 4 (YCT4).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 1',
    title: 'HSK 1 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 1 (HSK1).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 2',
    title: 'HSK 2 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 2 (HSK2).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 3',
    title: 'HSK 3 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 3 (HSK3).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 4',
    title: 'HSK 4 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 4 (HSK4).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 5',
    title: 'HSK 5 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 5 (HSK5).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HskAbout',
    key: 'HSK 6',
    title: 'HSK 6 on the only official platform for practising HSK tests',
    description:
      'Level description, test format and prescribed vocabulary plus real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 6 (HSK6).  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'YCTExamination',
    key: 'YCT 1',
    title: 'Real recent past YCT 1 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Youth Chinese Test Level 1 (YCT1), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'YCTExamination',
    key: 'YCT 2',
    title: 'Real recent past YCT 2 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Youth Chinese Test Level 2 (YCT2), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'YCTExamination',
    key: 'YCT 3',
    title: 'Real recent past YCT 3 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Youth Chinese Test Level 3 (YCT3), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'YCTExamination',
    key: 'YCT 4',
    title: 'Real recent past YCT 4 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Youth Chinese Test Level 4 (YCT4), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HSKExamination',
    key: 'HSK 1',
    title: 'Real recent past HSK 1 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 1 (HSK1), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HSKExamination',
    key: 'HSK 2',
    title: 'Real recent past HSK 2 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 2 (HSK2), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HSKExamination',
    key: 'HSK 3',
    title: 'Real recent past HSK 3 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 3 (HSK3), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HSKExamination',
    key: 'HSK 4',
    title: 'Real recent past HSK 4 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 4 (HSK4), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HSKExamination',
    key: 'HSK 5',
    title: 'Real recent past HSK 5 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 5 (HSK5), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
  {
    name: 'HSKExamination',
    key: 'HSK 6',
    title: 'Real recent past HSK 6 papers on the only official platform for practice',
    description:
      'Real recent past papers with which to practise for Chinese Level Test (Hanyu Shuiping Kaoshi) Level 5 (HSK5), plus level description, test format and prescribed vocabulary.  Developed in partnership with the HSK exam board and available via web and mobile app.',
  },
]
